import React, { useState, useEffect } from 'react'
import { Row, Col, ButtonGroup, IconButton, Icon, Table, Uploader, Message, Panel } from 'rsuite'
import { isRequiredFiled, isValidFileType } from '../../utils/ValidatorUtils'
import { cloneDeep, isEmpty } from 'lodash-es'
import notification from '../../utils/notification'
import EditDateCustomCell from '../../components/cell/EditDateCustomCell'
import moment from 'moment'
import { budgetFormat } from '../../utils/formatterUtil'
import EditNumberCell from '../../components/cell/EditNumberCell'
import InputNumberForm from '../../components/forms/input/InputNumberForm'
import EditTextCell from '../../components/cell/EditTextCell'
import { DD_MM_YYYY_SLASH } from '../../constants/date'
import EditSelectCell from '../../components/cell/EditSelectCell'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import EditMultiCascaderCell from '../../components/cell/EditMultiCascaderCell'

export default function ContractChangeExtendPeriodBudgetView({
  header,
  data,
  isBudget = true,
  bordered = true,
  collapsible = true,
  defaultExpanded = true,
  shaded = true,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const valKey = 'periodBudget'

  const [datas, setDatas] = useState(data || [])

  useEffect(() => {
    setDatas(data || [])
  }, [data])

  return (
    <Panel
      header={
        <div
          style={{
            backgroundColor: '#f9dcc2',
            margin: '-20px -20px', // ชดเชย padding ของ Panel เดิม เพื่อให้สีเต็มขอบ
            padding: '20px 20px', // ใส่ padding กลับเข้าไปให้สวยงาม
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
          }}
        >
          {header}
        </div>
      }
      eventKey={0}
      bordered={bordered}
      collapsible={collapsible}
      defaultExpanded={defaultExpanded}
      shaded={shaded}
    >
      <Row style={{ marginTop: 10 }}>
        {datas && (
          <Col xs={24} sm={24} md={24} lg={24}>
            <Table
              height={400}
              autoHeight={datas?.length <= 5}
              wordWrap
              bordered
              data={datas}
              style={{ marginBottom: 10 }}
            >
              <Column width={95} align="center">
                <HeaderCell>งวดที่</HeaderCell>
                <Cell dataKey={'period'} />
              </Column>
              <Column width={150}>
                <HeaderCell>วันที่เริ่มต้น</HeaderCell>
                <Cell dataKey={'newStartDate'} />
              </Column>
              <Column width={150}>
                <HeaderCell>วันที่สิ้นสุด</HeaderCell>
                <Cell dataKey={'newEndDate'} />
              </Column>

              {isBudget && (
                <Column width={180} align="right">
                  <HeaderCell>จำนวนเงินงวด</HeaderCell>
                  <Cell dataKey={'newAmount'} />
                </Column>
              )}

              <Column width={250} minWidth={250} flexGrow={1}>
                <HeaderCell>เหตุผล</HeaderCell>
                <Cell dataKey={'reasonTypeName'} />
              </Column>
              <Column width={250} minWidth={250} flexGrow={1}>
                <HeaderCell>กรณีอื่นๆ</HeaderCell>
                <Cell dataKey={'otherReason'} />
              </Column>
            </Table>
          </Col>
        )}
      </Row>
    </Panel>
  )
}
